import type { Incident, IncidentFeed } from "./types";

const INCIDENT_API_URL =
  import.meta.env.VITE_INCIDENT_API_URL?.trim() || "/incidents";

export async function fetchRecentIncidents(): Promise<Incident[]> {
  try {
    const response = await fetch(INCIDENT_API_URL, {
      headers: { accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    const data = (await response.json()) as IncidentFeed;
    return (data.incidents ?? []).map(normalizeIncident);
  } catch (error) {
    console.warn("Failed to load incidents from API, hiding banner", error);
    return [];
  }
}

function normalizeIncident(data: Incident): Incident {
  return {
    active: Boolean(data.active),
    severity: data.severity ?? "none",
    title: data.title ?? "",
    message: data.message ?? "",
    updatedAt: data.updatedAt ?? null,
  };
}
